"use strict";

exports.__esModule = true;
exports["default"] = exports.CheckboxInput = exports.CheckboxContainer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _input = _interopRequireDefault(require("../../primitives/input"));

var _text = _interopRequireDefault(require("../../primitives/text"));

var _fauxCheckbox = _interopRequireDefault(require("./faux-checkbox"));

var _glyph = _interopRequireDefault(require("../glyph"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _excluded = ["checkboxIsFocusedFromKeyboard"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckboxContainer = (0, _styledComponents["default"])(function (_ref) {
  var checkboxIsFocusedFromKeyboard = _ref.checkboxIsFocusedFromKeyboard,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_text["default"], props);
}).withConfig({
  displayName: "checkbox__CheckboxContainer",
  componentId: "sc-1sledbg-0"
})(["outline:", ";", ";", ";"], function (_ref2) {
  var checkboxIsFocusedFromKeyboard = _ref2.checkboxIsFocusedFromKeyboard;
  return checkboxIsFocusedFromKeyboard ? "2px solid highlight" : null;
}, function (_ref3) {
  var disabled = _ref3.disabled;

  if (disabled) {
    return "opacity: 0.6; cursor: default;";
  }

  return "cursor: pointer;";
}, _styledSystem.flexbox);
exports.CheckboxContainer = CheckboxContainer;
var CheckboxInput = (0, _styledComponents["default"])(_input["default"]).withConfig({
  displayName: "checkbox__CheckboxInput",
  componentId: "sc-1sledbg-1"
})(["position:absolute;appearance:none;opacity:0;margin:0;"]); // Fixes spacing on IE 11

exports.CheckboxInput = CheckboxInput;

var TextContainer = _styledComponents["default"].span.withConfig({
  displayName: "checkbox__TextContainer",
  componentId: "sc-1sledbg-2"
})(["flex:1 0 auto;flex-wrap:wrap;max-width:calc(100% - 16px);"]);

var defaultFont = {
  color: "body-grey",
  fontSize: 2,
  lineHeight: 2
};
var propTypes = {
  /** Checkbox width */
  checkBoxWidth: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),

  /** Checkbox font config */
  checkFontObject: _utils.fontPropType,

  /** -- even handler -- A function callback to process on checkbox change */
  checkboxOnChange: _propTypes.func,

  /** Checkbox container class name */
  className: _propTypes.string,

  /** A boolean to toggle checkbox disabled state */
  disabled: _propTypes.bool,

  /**  display styles */
  display: _propTypes.string,

  /** Checkbox rendering direction */
  flexDirection: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),

  /** String for checkbox field id */
  id: _propTypes.string,

  /** A boolean to represent whether the input field is indeterminate. Will be overridden by checked. */
  indeterminate: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),

  /** A boolean to represent whether the input field should be disabled */
  isChecked: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.number]),

  /** A boolean to represent if nested checkbox childred are shown */
  isChildShown: _propTypes.bool,

  /** A boolean to represent if checkbox is nested */
  isNested: _propTypes.bool,

  /** Checkbox container alignment  */
  justifyContent: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),

  /** Label for the input field */
  label: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Margin right value for checkbox icon */
  mr: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),

  /** -- even handler -- A function to callback to process when children are toggled */
  onNestedCheckToggle: _propTypes.func,

  /** Padding Y-axis for container */
  py: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),

  /** Checkbox input value */
  value: _propTypes.string,

  /** width of container */
  width: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string])
};

var Checkbox = function Checkbox(_ref4) {
  var id = _ref4.id,
      isChecked = _ref4.isChecked,
      _ref4$checkFontObject = _ref4.checkFontObject,
      checkFontObject = _ref4$checkFontObject === void 0 ? defaultFont : _ref4$checkFontObject,
      checkBoxWidth = _ref4.checkBoxWidth,
      className = _ref4.className,
      _ref4$display = _ref4.display,
      display = _ref4$display === void 0 ? "inline-flex" : _ref4$display,
      disabled = _ref4.disabled,
      indeterminate = _ref4.indeterminate,
      isNested = _ref4.isNested,
      isChildShown = _ref4.isChildShown,
      label = _ref4.label,
      checkboxOnChange = _ref4.checkboxOnChange,
      _ref4$justifyContent = _ref4.justifyContent,
      justifyContent = _ref4$justifyContent === void 0 ? "flex-start" : _ref4$justifyContent,
      flexDirection = _ref4.flexDirection,
      width = _ref4.width,
      value = _ref4.value,
      mr = _ref4.mr,
      onNestedCheckToggle = _ref4.onNestedCheckToggle,
      py = _ref4.py;

  /**
   * Because the interactive element of this component is the hidden checkbox input, the visible wrapping label element has to be aware of when the input has focus
   * When it has focus, display the focus outline via the CheckboxContainer styled component
   */
  var _useState = (0, _react.useState)(false),
      checkboxIsFocusedFromKeyboard = _useState[0],
      setCheckboxIsFocusedFromKeyboard = _useState[1];
  /**
   * onKeyUp event has no charCode or keyCode for tab, need to check key property
   * This checks that the element was navigated to via tab navigation; will not trigger the focus style if it's clicked on
   */


  var handleCheckboxKeyboardFocus = function handleCheckboxKeyboardFocus(_ref5) {
    var key = _ref5.key;
    if (key !== "Tab") return;
    setCheckboxIsFocusedFromKeyboard(true);
  };

  return /*#__PURE__*/_react["default"].createElement(CheckboxContainer, _extends({
    checkboxIsFocusedFromKeyboard: checkboxIsFocusedFromKeyboard,
    className: className,
    "data-test": "checkbox-label",
    disabled: disabled,
    display: display,
    flexDirection: flexDirection,
    justifyContent: justifyContent,
    position: "relative",
    py: py,
    tag: "label",
    textAlign: "left",
    width: width
  }, checkFontObject), /*#__PURE__*/_react["default"].createElement(CheckboxInput, {
    "aria-disabled": disabled,
    checked: disabled ? false : isChecked,
    id: id,
    indeterminate: indeterminate ? "true" : "false",
    onBlur: function onBlur() {
      return setCheckboxIsFocusedFromKeyboard(false);
    },
    onChange: disabled ? null : checkboxOnChange,
    onKeyUp: function onKeyUp(e) {
      return handleCheckboxKeyboardFocus(e);
    },
    py: py,
    readOnly: disabled || !checkboxOnChange,
    type: "checkbox",
    value: value
  }), /*#__PURE__*/_react["default"].createElement(_fauxCheckbox["default"], {
    checkBoxWidth: checkBoxWidth,
    checked: isChecked,
    indeterminate: indeterminate,
    isNested: isNested,
    mr: mr
  }), isNested ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    pr: 1
  }, /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    "data-test": "checkbox-checked",
    fill: checkFontObject.color,
    height: "16px",
    id: isChildShown ? "remove-minus" : "add-plus",
    onClick: function onClick(event) {
      event.preventDefault();

      if (onNestedCheckToggle) {
        onNestedCheckToggle();
      }
    },
    width: "16px"
  })), /*#__PURE__*/_react["default"].createElement(TextContainer, null, label)) : /*#__PURE__*/_react["default"].createElement(TextContainer, null, label));
};

Checkbox.propTypes = propTypes;
Checkbox.displayName = "Modules.Checkbox";
var _default = Checkbox;
exports["default"] = _default;